export { default as InputLeftElement } from './input-left-element';
